import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';
import {BuildingComplexesService} from "@/services/building-complexes.service";

export class ContractsService extends EntityService {
  static get entity() {
    return 'contracts';
  }

  static async getBillingPeriods() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/billing-periods`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async create(id, data = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        `${BuildingComplexesService.entity}/${id}/${this.entity}`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getBuildingComplexContract(documentsListsId, id) {
    try {
      const response = await this.request({ auth: true }).get(
        `${BuildingComplexesService.entity}/${id}/${this.entity}`
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async getPayableWithin() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/payable-within`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
